import axios from 'axios';
import config from '../config';

export async function startComposioConnection() {
  const api = axios.create({
    baseURL: config.apiUrl,
    withCredentials: true,
  });

  const { data } = await api.post('/auth/composio/initiate', {});
  if (data && data.redirect) {
    window.location.href = data.redirect;
  } else {
    throw new Error('Unable to start authentication flow');
  }
}
